let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5r7W9")).then(() => parcelRequire('egyYq'));